import React, { ReactNode } from "react";
import styled from "styled-components";
import { Card } from "antd";
import { CardProps } from "antd/lib/card/Card";

const CardContainer = styled(Card)`
  margin: 0rem;
  box-shadow: 0 1px 15px 1px rgba(81, 77, 92, 0.08);
`;

interface ICardProps {
  children: ReactNode;
  rest: CardProps;
}
const CardShadowed: React.FC<CardProps> = ({ children, ...rest }) => {
  return (
    <CardContainer
      headStyle={{
        fontWeight: 600,
        color: "var(--dark-grey-70)",
        fontSize: "1.25rem",
      }}
      {...rest}
    >
      {children}
    </CardContainer>
  );
};

export default CardShadowed;
